var Curriculog = Curriculog || {};

Curriculog.DateTypeFilter = (function ($, _, Backbone, DateTypeFilter) {

	DateTypeFilter = Backbone.View.extend({

		el: function () {
			return $('#report-9-date-type');
		},

		events: {
			'change': 'syncStatus'
		},

		initialize: function(options) {
			this.params = options.params;
			this.dateFromFilter = new Curriculog.DateFromFilter({params: this.params});
			this.dateToFilter = new Curriculog.DateToFilter({params: this.params});

			this.listenTo(Backbone, 'dateInputs:clear', this.clearDateInputs);
		},

		get: function() {
			// determine which date range object holds info, if any
			// note: on user side, we send both completed and exported,
			// but the UI only lists completed; thus we test for that first
			var dateType = '',
				from = '',
				to = '',
				launchedDates = this.params.queryParams.get('launchedDateRange'),
				completedDates = this.params.queryParams.get('completedDateRange'),
				exportedDates = this.params.queryParams.get('exportedDateRange'),
				tab = this.params.domParams.get('tab');

			if (! _.isEmpty(completedDates)) {
				dateType = 'completedDateRange';
			} else if (! _.isEmpty(exportedDates)) {
				dateType = 'exportedDateRange';
			} else if (! _.isEmpty(launchedDates)) {
				dateType = 'launchedDateRange';
			}

			this.$el.find('option[value="'+ dateType +'"]').prop('selected', true);

			if (dateType !== '') {
				from = this.params.queryParams.get(dateType).from;
				to = this.params.queryParams.get(dateType).to;
			}

			// if we came from simple filter, don't set from and to date, just the type
			// we have to precalculate from and to for simple filter only, but that can
			// confuse a user if they open the advanced filter after performing a simple filter search
			if (this.params.domParams.get('filterType') === 'simple') {
				from = '';
				to = '';
			}

			this.dateFromFilter.get(from);
			this.dateToFilter.get(to);

			this.$el.find('option').prop('disabled', false);

			if (_.indexOf(['task','mine','watching','needsattention'], tab) !== -1) {
				this.$el.find('option[value="completedDateRange"]').prop('disabled', true);
			}

			if (tab === 'needsattention') {
				this.$el.find('option[value="exportedDateRange"]').prop('disabled', true);
			}

			// Trigger the select2 change event to update the 'selected' option
			this.$el.selectWoo('destroy').selectWoo({
                theme: 'curriculog'
            });
			var label = this.$el.next().find('.select2-selection--single').attr('aria-labelledby');
			this.$el.next().find('.select2-selection--single').attr('aria-labelledby', this.$el.attr('id') + '-label' + ' ' + label );
		},

		set: function() {
			var dateRange = {
				from: this.dateFromFilter.set(),
				to: this.dateToFilter.set()
			};

			var dateType = this.$el.val();


			if (dateType === '') {
				return;
			}

			dateRange = this.params.queryParams.validateDateRange(dateRange);
			if (dateType === 'exportedDateRange') {
				this.params.queryParams.set('exportedDateRange', dateRange);

			} else if (dateType === 'completedDateRange') {
				this.params.queryParams.set('completedDateRange', dateRange);
				this.syncDateRange(this.params.domParams.get('tab'), dateRange);

			} else if (dateType === 'launchedDateRange') {
				this.params.queryParams.set('launchedDateRange', dateRange);
			}
		},

		validate: function() {
			/*
				Prior to submitting the Advanced Filter, we need to validate the date range function
				and its date subviews to be sure all the data is logical.

				We get defaultDateRange from QueryParams for empty values in either from or two date.
			*/
			var defaultDateRange = this.params.queryParams.validateDateRange({from: '', to: ''}),
				$type = $(this.el),
				$from = $(this.dateFromFilter.el),
				$to = $(this.dateToFilter.el),
				fromDate = ($from.val().length > 0) ? new Date($from.val()) : new Date(defaultDateRange.from),
				toDate = ($to.val().length > 0) ? new Date($to.val()) : new Date(defaultDateRange.to);

			this.setupErrorPosition();

			$.validity.start();

			$type.assert(function() {
				if (
					($from.val().length > 0 || $to.val().length > 0) &&
					($type.val().length === 0)
				) {
					return false;
				}
				return true;
			}, 'You must select a type of date range to search');

			// We have to explicit express that the year has to be a full 4 digit year and cannot use the 'date'
			// rule from validity as it accepts truncated 2 digit years
			$from.match(/^((0?\d)|(1[012]))\/([012]?\d|30|31)\/\d{4}$/, 'From date must be a date formatted mm/dd/yyyy.')
			.assert(function() {
				if (isNaN(fromDate.getTime())) {
					return false;
				}
				return true;
			}, 'From date must be a valid date');

			// We have to explicit express that the year has to be a full 4 digit year and cannot use the 'date'
			// rule from validity as it accepts truncated 2 digit years
			$to.match(/^((0?\d)|(1[012]))\/([012]?\d|30|31)\/\d{4}$/, 'To date must be a date formatted mm/dd/yyyy.')
			.assert(function() {
				if (isNaN(toDate.getTime())) {
					return false;
				}
				return true;
			}, 'From date must be a valid date')
			.assert(function() {
				if (fromDate > toDate) {
					return false;
				}
				return true;
			}, 'From date must be less than or equal to To date');

			return $.validity.end();
		},

		syncDateRange: function(tab, dateRange) {
			/*
				A user-side search of proposals using completedDateRange means we search for all
				proposals of completed status within the date range, regardless of export status.

				Selecting CompletedDateRange for the user side search needs to sync up
				CompletedDateRange and ExportedDateRange
			*/
			if (tab !== 'all-proposals') {
				return;
			}

			this.params.queryParams.set('exportedDateRange', dateRange);
		},

		syncStatus: function() {
			if (_.indexOf(['completedDateRange','exportedDateRange'], this.$el.val()) !== -1) {
				Backbone.trigger('dateType:changed');
			}
		},

		cleanValidity: function() {
			this.removeClass("error");
		},

		setupErrorPosition: function () {
			var that = this;
			$.validity.outputs.afterSelect2 = {
				start: function () {
          if (that.params.cui_enabled) {
            that.$el.parents('.date-range').find('.error').remove();
  					that.$el.parents('.date-range').siblings('.field-date').find('.error').remove();
          } else {
            that.$el.parents('li').find('.error').remove();
  					that.$el.parents('li').siblings('.field-date').find('.error').remove();
          }

				},
				end: function (results) {
					if (results.valid) {
            if (that.params.cui_enabled) {
              that.$el.parents('.date-range').find('.error').remove();
  						that.$el.parents('.date-range').siblings('.field-date').find('.error').remove();
            } else {
              that.$el.parents('li').find('.error').remove();
  						that.$el.parents('li').siblings('.field-date').find('.error').remove();
            }

					}
				},
				raise: function ($obj, msg) {
					if ($obj.context.tagName === 'SELECT') {
						$obj
							.next('span')
							.after(
								$('<span/>', {
									for: $obj.attr('id'),
									class: 'error',
								})
									.html(msg)
							);
						} else {
							$obj
								.after(
									$('<span/>', {
										for: $obj.attr('id'),
										class: 'error',
									})
										.html(msg)
								);
						}

				},
				raiseAggregate: function () {},
			};

			$.validity.setup({outputMode: 'afterSelect2'});
		},

		clearDateInputs: function () {
			var $parents = this.$el.parents('li');
      if (this.params.cui_enabled) {
        $parents = this.$el.parents('.date-range');
      }

			this.$el.val('').trigger('change.select2');
			$parents.find('.error').remove();
			$parents.siblings('.field-date').find('.error').remove();

			_.each([this.dateFromFilter, this.dateToFilter], function (filter) {
				filter.$el.val('');
			});
		}

	});

	return DateTypeFilter;

})($, _, Backbone, Curriculog.DateTypeFilter || {});
